import axios from "axios";
import { API } from "../../backend";
import authHeader from "../auth-header";

const getAll = (params) =>
  axios.get(API + "creditmemo/", { headers: authHeader(), params });

const getById = (id) =>
  axios.get(API + `creditmemo/${id}/`, { headers: authHeader() });

const create = (data) =>
  axios.post(API + "creditmemo/", data, { headers: authHeader() });

const update = (id, data) =>
  axios.put(API + `creditmemo/${id}/`, data, { headers: authHeader() });

const remove = (id) =>
  axios.delete(API + `creditmemo/${id}/`, { headers: authHeader() });

const finalize = (id) =>
  axios.post(API + `creditmemo/${id}/finalize/`, {}, { headers: authHeader() });

const uploadAttachment = (id, file) => {
  const formData = new FormData();
  formData.append("file", file);
  return axios.post(API + `creditmemo/${id}/attachments/`, formData, {
    headers: { ...authHeader(), "Content-Type": "multipart/form-data" },
  });
};

const getByInvoice = (invoiceId) =>
  axios.get(API + `creditmemo/invoice/${invoiceId}/`, { headers: authHeader() });

const applyToInvoice = (id, invoiceId, applyAmount) =>
  axios.post(API + `creditmemo/${id}/apply-invoice/`, {
    invoice_id:   invoiceId,
    apply_amount: applyAmount,
  }, { headers: authHeader() });

const reverse = (id, reverseReason) =>
  axios.post(API + `creditmemo/${id}/reverse/`, {
    reverse_reason: reverseReason,
  }, { headers: authHeader() });

const CreditMemoService = {
  getAll,
  getById,
  create,
  update,
  remove,
  finalize,
  uploadAttachment,
  getByInvoice,
  applyToInvoice,
  reverse,
};

export default CreditMemoService;